import * as React from "react";
import { IParagraphFooterCtaProps } from "./ParagraphFooterCtaProps";
import { Container } from "./ParagraphFooterCtaHelpers";
import { graphql, Slice } from "gatsby";
import { FooterCtaSliceProvider } from "../../../context/SliceContexts/FooterCtaContext";

const ParagraphFooterCta: React.FC<IParagraphFooterCtaProps> = (props) => {
  return (
    <Container>
      <FooterCtaSliceProvider value={{ ...props.node }}>
        <Slice alias="footer-cta" />
      </FooterCtaSliceProvider>
    </Container>
  );
};
export const fragment = graphql`
  fragment ParagraphFooterCta on paragraph__footer_cta {
    id
    field_title
    field_link {
      url
      title
    }
    relationships {
      field_media {
        relationships {
          field_media_file {
            publicUrl
          }
        }
      }
    }
  }
`;
export default ParagraphFooterCta;
